import CreditIcon from 'src/assets/icons/CreditIcon.svg';
import {
  Hero,
  HeroBadge,
  HeroCloseButton,
  HeroSubtitle,
  HeroText,
  HeroTitle,
} from './styles/CreditsHero.styles';

export type CreditsHeroProps = {
  title: string;
  subtitle: string;
  compact?: boolean;
  onClose?: () => void;
};

const CreditsHero = ({
  title,
  subtitle,
  compact,
  onClose,
}: CreditsHeroProps) => (
  <Hero compact={compact}>
    <HeroBadge compact={compact}>
      <img
        src={CreditIcon}
        alt=""
        width={compact ? 22 : 28}
        height={compact ? 22 : 28}
      />
    </HeroBadge>
    <HeroText>
      <HeroTitle compact={compact}>{title}</HeroTitle>
      <HeroSubtitle compact={compact}>{subtitle}</HeroSubtitle>
    </HeroText>
    {onClose && (
      <HeroCloseButton type="button" aria-label="Close" onClick={onClose}>
        ×
      </HeroCloseButton>
    )}
  </Hero>
);

export default CreditsHero;
